/*
  Einheitliche Fehlernormalisierung für die neue Schichtplan-Seite.
*/

export function normalizeApiError(error) {
  const message =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    "Der Schichtplan konnte nicht geladen werden.";

  return {
    status: error?.response?.status || 500,
    message,
  };
}
